/* eslint-disable */
import { useParams, useNavigate, useLocation, Link } from "react-router-dom";
import { useEffect, useState } from "react";

import Toaster from "../Toaster/Toaster";
import ConfirmationModal from "../Modern/ConfirmationModal";

import {
  Button,
  Row,
  Col,
  Container,
  Table,
  Form,
  Alert,
} from "react-bootstrap";

import CreateMenu from "../CreateMenu";
import SimpleMenu from "../SimpleMenu";

import { EscalationAPI } from "../../connections/fetchEscalations";
import { ConfigurationAPI } from "../../connections/Configuration";

// Generated by GitHub Copilot
import { FaExternalLinkAlt } from "react-icons/fa";
import { generatePagerDutyWorkflowURL } from "../../utils/pagerDutyUtils";
import styles from './DeliveryStream.module.css';
import { FaEdit, FaTrash, FaArrowLeft } from 'react-icons/fa';

const escalationPrefix = "EOC IC";

function Management({ user }) {
  let params = useParams();
  let navigate = useNavigate();
  const location = useLocation();

  const [saved, setSaved] = useState(true);
  const [saving, setSaving] = useState(false); // es-lint-disable no-unused-vars
  const [error, setError] = useState("");
  const [toast, setToast] = useState(); // es-lint-disable no-unused-vars
  const [loaded, setLoaded] = useState(false);
  const [sequence, setSequence] = useState(0);

  const [productID, setProductID] = useState();
  const [details, setDetails] = useState({});
  const [deliveryStreams, setDeliveryStreams] = useState([]);
  const [definitions, setDefinitions] = useState([]);

  const [portfolio, setPortfolio] = useState("");
  const [title, setTitle] = useState("");
  const [icPolicy, setICPolicy] = useState({});
  const [leaderWorkflow, setLeaderWorkflow] = useState({});

  const [newProduct, setNewProduct] = useState(false);

  const [menuOptions, setMenuOptions] = useState({
    portfolios: [],
    deliveryStreams: [],
  });

  const [icEPs, seticEPs] = useState([]);
  const [workflows, setWorkflows] = useState();

  // Generated by GitHub Copilot
  // State for PagerDuty configuration
  const [configuration, setConfiguration] = useState({});

  // Generated by GitHub Copilot
  // State for user search functionality
  const [searchTerm, setSearchTerm] = useState("");
  const [searchResults, setSearchResults] = useState([]);
  const [searchLoading, setSearchLoading] = useState(false);
  const [searchError, setSearchError] = useState("");
  const [showSearchResults, setShowSearchResults] = useState(false);

  // Generated by GitHub Copilot
  // State for multi-select commander assignment
  const [selectedCommanders, setSelectedCommanders] = useState([]);
  const [currentCommanders, setCurrentCommanders] = useState([]);
  const [assignmentLoading, setAssignmentLoading] = useState(false);
  const [assignmentError, setAssignmentError] = useState("");
  const [assignmentSuccess, setAssignmentSuccess] = useState("");

  // State for delete confirmation modal
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [streamToDelete, setStreamToDelete] = useState(null);
  const [deleteFromDetail, setDeleteFromDetail] = useState(false);

  // Generated by GitHub Copilot
  // Check user privileges for delivery stream configuration
  const hasConfigurationPrivilege =
    user && user.privileges && user.privileges.configuration;
  const canViewDeliveryStreams =
    user &&
    user.privileges &&
    (user.privileges.configuration ||
      user.privileges.editor ||
      user.privileges.deity);

  // Generated by GitHub Copilot
  // Determine if forms should be read-only based on privileges
  const isReadOnlyMode = !hasConfigurationPrivilege;

  // Generated by GitHub Copilot
  // Access control for users without viewing privileges
  if (!canViewDeliveryStreams) {
    return (
      <Container>
        <Row>
          <Col>
            <Alert variant="warning" className="mt-4">
              <Alert.Heading>Access Restricted</Alert.Heading>
              <p>
                You need configuration, editor, or administrator privileges to
                view delivery stream details.
              </p>
              <hr />
              <p className="mb-0">
                <small>
                  Contact your administrator if you need access to this feature.
                </small>
              </p>
            </Alert>
          </Col>
        </Row>
      </Container>
    );
  }

  const clearError = () => {
    setError("");
    setSearchError("");
    setAssignmentError("");
    setAssignmentSuccess("");
  };

  // Generated by GitHub Copilot
  // Handle commander selection and assignment
  const handleCommanderSelect = (user) => {
    // Validate user has required fields before allowing selection
    if (
      !user.displayName ||
      typeof user.displayName !== "string" ||
      user.displayName.trim().length === 0
    ) {
      setAssignmentError(
        "This user has an invalid display name and cannot be selected."
      );
      return;
    }

    const isSelected = selectedCommanders.find((cmd) => cmd.id === user.id);

    if (isSelected) {
      // Remove commander from selection
      setSelectedCommanders(
        selectedCommanders.filter((cmd) => cmd.id !== user.id)
      );
    } else {
      // Add commander to selection
      setSelectedCommanders([...selectedCommanders, user]);
    }
  };

  const isCommanderSelected = (user) => {
    return selectedCommanders.some((cmd) => cmd.id === user.id);
  };

  const isCommanderAlreadyAssigned = (user) => {
    return currentCommanders.some(
      (cmd) =>
        user.displayName &&
        (cmd.toLowerCase() === user.displayName.toLowerCase() ||
          (user.mail && cmd.toLowerCase() === user.mail.toLowerCase()))
    );
  };

  const assignSelectedCommanders = () => {
    if (selectedCommanders.length === 0) {
      setAssignmentError("Please select at least one commander to assign");
      return;
    }

    // Generated by GitHub Copilot
    // Filter and validate commander names
    const commanderNames = selectedCommanders
      .map((cmd) => cmd.displayName)
      .filter(
        (name) => name && typeof name === "string" && name.trim().length > 0
      )
      .map((name) => name.trim());

    if (commanderNames.length === 0) {
      setAssignmentError(
        "Selected commanders have invalid names. Please try selecting different users."
      );
      return;
    }

    // Generated by GitHub Copilot
    // Add commanders to local state only - API call happens on save
    const newCommanders = [...currentCommanders];
    let addedCount = 0;

    commanderNames.forEach((name) => {
      // Check for duplicates (case-insensitive)
      const isDuplicate = newCommanders.some(
        (existing) => existing.toLowerCase() === name.toLowerCase()
      );

      if (!isDuplicate) {
        newCommanders.push(name);
        addedCount++;
      }
    });

    if (addedCount === 0) {
      setAssignmentError("All selected commanders are already assigned.");
      return;
    }

    // Update local state with filtered commanders
    const filteredCommanders = newCommanders.filter(
      (cmd) => cmd && typeof cmd === "string" && cmd.trim().length > 0
    );
    setCurrentCommanders(filteredCommanders);
    setDetails((prev) => ({
      ...prev,
      incident_commanders: filteredCommanders,
    }));

    // Clear selections and show success message
    setSelectedCommanders([]);
    setAssignmentSuccess(
      `Added ${addedCount} commander(s). Click "Save Changes" to persist.`
    );
    setAssignmentError("");

    // Auto-dismiss success message after 3 seconds
    setTimeout(() => {
      setAssignmentSuccess("");
    }, 3000);

    // Mark as unsaved since we've made changes
    setSaved(false);
  };

  const removeCommander = (commanderName) => {
    // Generated by GitHub Copilot
    // Remove commander from local state only - API call happens on save
    const updatedCommanders = currentCommanders
      .filter((cmd) => cmd && typeof cmd === "string" && cmd !== commanderName)
      .filter((cmd) => cmd.trim().length > 0); // Also remove empty strings

    // Update local state
    setCurrentCommanders(updatedCommanders);
    setDetails((prev) => ({
      ...prev,
      incident_commanders: updatedCommanders,
    }));

    setAssignmentSuccess(
      `Removed ${commanderName}. Click "Save Changes" to persist.`
    );
    setAssignmentError("");

    // Auto-dismiss success message after 3 seconds
    setTimeout(() => {
      setAssignmentSuccess("");
    }, 3000);

    // Mark as unsaved since we've made changes
    setSaved(false);
  };

  // Generated by GitHub Copilot
  // Handle user search functionality
  const handleSearchTermChange = (e) => {
    setSearchTerm(e.target.value);
    if (e.target.value.length <= 3) {
      setShowSearchResults(false);
      setSearchResults([]);
    }
  };

  const searchUsers = async () => {
    if (searchTerm.trim().length <= 3) {
      setSearchError("Last name must be more than 3 characters");
      return;
    }

    setSearchLoading(true);
    setSearchError("");
    setAssignmentError("");
    setAssignmentSuccess("");
    setShowSearchResults(false);

    try {
      const response = await fetch(
        `/api/v1/users/search?lastName=${encodeURIComponent(searchTerm.trim())}`
      );

      if (response.status === 401) {
        setSearchError(
          "Authentication required. Please refresh and try again."
        );
        setSearchLoading(false);
        return;
      }

      if (!response.ok) {
        throw new Error(`Search failed with status: ${response.status}`);
      }

      const data = await response.json();
      setSearchResults(data.users || []);
      setShowSearchResults(true);

      if (!data.users || data.users.length === 0) {
        setSearchError("No users found with that last name");
      }
    } catch (error) {
      console.error("Search error:", error);
      setSearchError("Failed to search users. Please try again.");
    } finally {
      setSearchLoading(false);
    }
  };

  const handleSearchKeyPress = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      searchUsers();
    }
  };

  const saveChanges = () => {
    const payload = {
      products: details.products
        ? details.products.map((p) => {
            return p && p.label !== "" && p.label;
          })
        : [],

      name: title,
      portfolio: portfolio,
      ic_policy: icPolicy,
      leadership_workflow: leaderWorkflow,
      // Generated by GitHub Copilot
      // Include current commanders in the save payload
      incident_commanders: currentCommanders,
    };

    let requestOptions = {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
      uri: "/api/v1/library/delivery/" + details.id,
    };

    if (newProduct) {
      requestOptions.method = "POST";
      requestOptions.uri = "/api/v1/library/delivery";
    }

    fetch(requestOptions.uri, requestOptions)
      .then((res) => {
        if (res.ok) {
          return res.json();
        }
      })
      .catch((error) => {
        console.log(error);
        setError(error);
      })
      .then((response) => {
        setSaving(true);
        // Generated by GitHub Copilot
        // Reset search state after successful save
        setSearchTerm("");
        setSearchResults([]);
        setShowSearchResults(false);
        setSelectedCommanders([]);
        setSearchError("");
        setAssignmentError("");
        setAssignmentSuccess("");

        setTimeout(() => {
          setSaving(false);
          setProductID();
          setSequence(sequence + 1);
          setNewProduct(false);

          navigate(`/configuration`);
          return;
        }, 1500);
        setSaved(true);
      });
  };

  const deleteProduct = () => {
    // Set up for detail page delete
    setStreamToDelete(details);
    setDeleteFromDetail(true);
    setShowDeleteModal(true);
  };

  const confirmDeleteProduct = () => {
    setShowDeleteModal(false);
    setStreamToDelete(null);
    setDeleteFromDetail(false);

    setSaving(true);
    setTimeout(() => {
      setSaving(false);
    }, 1000);
    let requestOptions = {
      method: "DELETE",
      headers: { Accept: "application/json" },
      uri: "/api/v1/library/delivery/" + details.id,
    };

    fetch(requestOptions.uri, requestOptions)
      .then((res) => {
        if (res.ok) {
          return res.json();
        }
      })
      .catch((error) => {
        console.log(error);
        setError(error);
      })
      .then((response) => {
        setProductID();
        setNewProduct(false);
        setSequence(sequence + 1);
        navigate("/configuration");
      });
  };

  const fetchDeliveryStreams = () => {
    return fetch("/api/v1/library/delivery")
      .then((res) => {
        if (res.ok) {
          return res.json();
        }
        throw new Error("not ok");
      })
      .catch((error) => {
        console.log(error);
      })
      .then((response) => {
        let portfolioCollection = {};
        let deliveryStreamCollection = {};

        response &&
          response.forEach((item) => {
            portfolioCollection[item.portfolio]++;
            deliveryStreamCollection[item.delivery_stream]++;
          });

        const uniquePortfolios = Object.keys(portfolioCollection);

        const portfolioOptions = uniquePortfolios.map((po) => {
          return createOption(po);
        });

        setMenuOptions({
          ...menuOptions,
          portfolios: portfolioOptions,
        });

        return response;
      });
  };

  const handlePortfolioChange = (p) => {
    setDetails({ ...details, portfolio: p });
    setPortfolio(p.label);
    setSaved(false);
  };

  const handleICEscalationChange = (ic) => {
    setDetails({ ...details, ic_policy: ic });
    setICPolicy(ic);
    setSaved(false);
  };

  const handleWorkflowChange = (ldr) => {
    setDetails({ ...details, leadership_workflow: ldr });
    setLeaderWorkflow(ldr);
    setSaved(false);
  };

  const handleProductChange = (e) => {
    setDetails({ ...details, products: e });
    setSaved(false);
  };

  const handleProductCreate = (e) => {
    details.products ? details.products.unshift(e) : (details.products = [e]);

    setDetails({ ...details, products: details.products });
    setSaved(false);
  };

  const createOptionWithValue = (label, value) => ({
    label: label,
    value: value,
  });

  const createOption = (label) => ({
    label: label,
    value: label,
  });

  useEffect(() => {
    const { id } = params;
    const isNewDeliveryStream = location.pathname.endsWith('/new');

    // Check if this is a "new" product creation via URL
    if (isNewDeliveryStream) {
      setNewProduct(true);
      setProductID(undefined);
      return; // Don't try to fetch a product with ID "new"
    }

    if (id) {
      setNewProduct(false);
      deliveryStreams &&
        deliveryStreams.forEach((item) => {
          if (item.id && item.id === id) {
            setProductID(id);

            const productOptions = item.products.map((i) => {
              return createOptionWithValue(i, i);
            });

            const icPolicy = createOptionWithValue(
              item.ic_policy.label,
              item.ic_policy.value
            );

            setICPolicy(icPolicy);

            const leaderWorkflow = createOptionWithValue(
              item.leadership_workflow.label,
              item.leadership_workflow.value
            );

            setLeaderWorkflow(leaderWorkflow);

            setDetails({
              ...item,
              portfolio: createOption(item.portfolio),

              // ic_policy: item.ic_policy,
              // ic_policy: icPolicy,
              // leadership_workflow: leaderWorkflow,
              products: productOptions.map((p) => {
                return p.value != "" ? p : undefined;
              }),
            });
            setPortfolio(item.portfolio);
            setTitle(item.name);

            // Generated by GitHub Copilot
            // Set current commanders from delivery stream data with validation
            const commanders = item.incident_commanders || [];
            const validCommanders = commanders.filter(
              (cmd) => cmd && typeof cmd === "string" && cmd.trim().length > 0
            );
            setCurrentCommanders(validCommanders);
          }
        });
    }
  }, [params, deliveryStreams, location.pathname]);

  useEffect(() => {
    setSequence(1);

    // Generated by GitHub Copilot
    // Fetch configuration for PagerDuty hostname
    ConfigurationAPI.get()
      .then((config) => {
        setConfiguration(config);
      })
      .catch((err) => {
        console.error("Error fetching configuration:", err);
      });

    EscalationAPI.getWorkflows("EOC IC P2B")
      .then((data) => {
        let icOptions = data.workflows
          ? data.workflows.map((p) => {
              return createOptionWithValue(p.name, p.id);
            })
          : [];

        icOptions[icOptions.length] = createOption("None", "none");
        seticEPs(icOptions);

        EscalationAPI.getWorkflows("EOC Lead").then((data) => {
          let workflowOptions = data.workflows
            ? data.workflows.map((w) => {
                return createOptionWithValue(w.name, w.id);
              })
            : [];
          workflowOptions[workflowOptions.length] = createOption(
            "None",
            "none"
          );

          setWorkflows(workflowOptions);
        });
      })
      .catch((err) => {
        console.log(error);
      });
  }, []);

  useEffect(() => {
    setSaved(true);
    fetchDeliveryStreams().then((defs) => {
      const definitionRows =
        defs &&
        defs.map((def) => {
          const defLink = "/configuration/deliverystream/" + def.id;
          return (
            <tr key={def.id}>
              <td>
                <Link to={defLink}>{def.name}</Link>
              </td>
              <td>{def.portfolio}</td>
            </tr>
          );
        });
      setDeliveryStreams(defs);
      setDefinitions(definitionRows);
    });
  }, [sequence]);

  const updateTitle = (event) => {
    setDetails({
      ...details,
      [event.target.id]: event.target.value,
    });
    setTitle(event.target.value);
    setSaved(false);
  };

  const handleEdit = (deliveryStreamId) => {
    navigate(`/configuration/deliverystream/${deliveryStreamId}`);
  };

  const handleDelete = () => {
    if (!streamToDelete) return;

    const deliveryStream = streamToDelete;
    setShowDeleteModal(false);
    setStreamToDelete(null);

    const requestOptions = {
      method: "DELETE",
      headers: { Accept: "application/json" },
    };

    fetch(`/api/v1/library/delivery/${deliveryStream.id}`, requestOptions)
      .then((res) => {
        if (res.ok) {
          return res.json();
        }
        throw new Error("Delete failed");
      })
      .then(() => {
        setSequence(sequence + 1); // Trigger refresh
      })
      .catch((error) => {
        console.error("Delete error:", error);
        setError("Failed to delete delivery stream");
      });
  };

  const createNewDeliveryStream = () => {
    setNewProduct(true);
    setDetails({});
  };

  return (
    <Container>
      <Toaster
        saved={saved}
        error={error}
        clearError={clearError}
        saving={saving}
        loaded={true}
        connected={true}
        message={toast}
      />
      {!productID && !newProduct ? (
        <>
          <Row className="firstRow">
            <Col>
              <Button variant="secondary" onClick={createNewDeliveryStream}>
                New Delivery Stream
              </Button>
            </Col>
          </Row>
          <Row>
            <Col>
              {/* Desktop Table */}
              <table className={styles.table}>
                <thead>
                  <tr>
                    <th className={styles.tableCell}>Delivery Stream</th>
                    <th className={styles.tableCell}>Portfolio</th>
                    <th className={styles.tableCell} style={{ textAlign: 'right' }}>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {deliveryStreams && deliveryStreams.length > 0 ? (
                    deliveryStreams.map((ds) => (
                      <tr key={ds.id} className={styles.tableRow}>
                        <td className={styles.tableCell}>
                          <Link
                            to={`/configuration/deliverystream/${ds.id}`}
                            className={styles.link}
                          >
                            {ds.name}
                          </Link>
                        </td>
                        <td className={styles.tableCell}>{ds.portfolio}</td>
                        <td className={styles.tableCell}>
                          <div className={styles.actionButtons}>
                            {hasConfigurationPrivilege ? (
                              <>
                                <button
                                  className={styles.iconButton}
                                  onClick={() => handleEdit(ds.id)}
                                  title="Edit delivery stream"
                                  aria-label={`Edit ${ds.name}`}
                                >
                                  <FaEdit />
                                </button>
                                <button
                                  className={`${styles.iconButton} ${styles.iconButtonDanger}`}
                                  onClick={() => {
                                    setStreamToDelete(ds);
                                    setDeleteFromDetail(false);
                                    setShowDeleteModal(true);
                                  }}
                                  title="Delete delivery stream"
                                  aria-label={`Delete ${ds.name}`}
                                >
                                  <FaTrash />
                                </button>
                              </>
                            ) : (
                              <span className={styles.readOnlyText} title="Read-only access">
                                View only
                              </span>
                            )}
                          </div>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="3" className={styles.tableCell} style={{ textAlign: 'center' }}>
                        No Delivery Streams Currently Defined
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>

              {/* Mobile Card Layout */}
              <div className={styles.cardList}>
                {deliveryStreams && deliveryStreams.length > 0 ? (
                  deliveryStreams.map((ds) => (
                    <div key={ds.id} className={styles.card}>
                      <div className={styles.cardHeader}>
                        <Link
                          to={`/configuration/deliverystream/${ds.id}`}
                          className={styles.cardTitle}
                        >
                          {ds.name}
                        </Link>
                      </div>
                      <div className={styles.cardBody}>
                        <div className={styles.cardField}>
                          <span className={styles.cardLabel}>Portfolio:</span>
                          <span className={styles.cardValue}>{ds.portfolio}</span>
                        </div>
                      </div>
                      {hasConfigurationPrivilege && (
                        <div className={styles.cardActions}>
                          <button
                            className={`${styles.cardButton} ${styles.cardButtonPrimary}`}
                            onClick={() => handleEdit(ds.id)}
                            aria-label={`Edit ${ds.name}`}
                          >
                            <FaEdit /> Edit
                          </button>
                          <button
                            className={`${styles.cardButton} ${styles.cardButtonDanger}`}
                            onClick={() => {
                              setStreamToDelete(ds);
                              setDeleteFromDetail(false);
                              setShowDeleteModal(true);
                            }}
                            aria-label={`Delete ${ds.name}`}
                          >
                            <FaTrash /> Delete
                          </button>
                        </div>
                      )}
                    </div>
                  ))
                ) : (
                  <div className={styles.emptyState}>
                    No Delivery Streams Currently Defined
                  </div>
                )}
              </div>
            </Col>
          </Row>
        </>
      ) : (
        <>
          <div className={styles.breadcrumb}>
            <Link
              to="/configuration"
              className={styles.backLink}
              onClick={() => {
                setProductID();
                setNewProduct(false);
              }}
            >
              <FaArrowLeft /> Manage Delivery Streams
            </Link>
          </div>
          <Form>
            <Row>
              <Col xl={6} sm={6} md={6} lg={12}>
                <Form.Group className="mb-3" controlId="name">
                  <Form.Label>Delivery Stream Name</Form.Label>
                  <Form.Control
                    size="md"
                    type="text"
                    placeholder="Title Vault 8"
                    value={details && details.name ? details.name : ""}
                    readOnly={isReadOnlyMode}
                    onChange={updateTitle}
                  />
                </Form.Group>
              </Col>
              <Col xl={6} sm={6} md={6} lg={12}>
                <Form.Group className="mb-3" controlId="portfolio">
                  <Form.Label>Portfolio</Form.Label>
                  <CreateMenu
                    multi={false}
                    options={menuOptions.portfolios}
                    onChange={handlePortfolioChange}
                    creatableCallback={(e) => {
                      console.log(e);
                    }}
                    defaultValue={details.portfolio}
                    readOnly={isReadOnlyMode || !loaded}
                  />
                </Form.Group>
              </Col>
            </Row>

            <Row>
              <Col xl={6} sm={6} md={6} lg={6}>
                <Form.Group className="mb-3" controlId="ic_escalation">
                  <Form.Label>IC Workflow</Form.Label>
                  <SimpleMenu
                    options={icEPs}
                    onChange={handleICEscalationChange}
                    defaultValue={details.ic_policy}
                    readOnly={isReadOnlyMode}
                  />
                </Form.Group>
              </Col>
              <Col xl={6} sm={6} md={6} lg={6}>
                <Form.Group className="mb-3" controlId="ic_escalation">
                  <Form.Label>Leadership P2B Workflow</Form.Label>
                  <SimpleMenu
                    options={workflows}
                    onChange={handleWorkflowChange}
                    defaultValue={details.leadership_workflow}
                    readOnly={isReadOnlyMode}
                  />
                </Form.Group>
              </Col>
            </Row>

            {/* Generated by GitHub Copilot */}
            {/* PagerDuty workflow links row */}
            <Row className="mb-3">
              <Col xl={6} sm={6} md={6} lg={6}>
                {/* View in PagerDuty link for IC Workflow */}
                {(() => {
                  const workflowId =
                    details.ic_policy?.value || icPolicy?.value;
                  const url = generatePagerDutyWorkflowURL(
                    workflowId,
                    configuration
                  );
                  return url ? (
                    <Form.Text className="text-muted workflow-helper-text">
                      <a
                        href={url}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="pagerduty-workflow-link"
                        aria-label={`View IC Workflow ${workflowId} in PagerDuty`}
                        title={`Open workflow ${workflowId} in PagerDuty (opens in new tab)`}
                      >
                        <FaExternalLinkAlt className="pagerduty-link-icon" />
                        View in PagerDuty
                      </a>
                    </Form.Text>
                  ) : null;
                })()}
              </Col>
              <Col xl={6} sm={6} md={6} lg={6}>
                {/* View in PagerDuty link for Leadership P2B Workflow */}
                {(() => {
                  const workflowId =
                    details.leadership_workflow?.value || leaderWorkflow?.value;
                  const url = generatePagerDutyWorkflowURL(
                    workflowId,
                    configuration
                  );
                  return url ? (
                    <Form.Text className="text-muted workflow-helper-text">
                      <a
                        href={url}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="pagerduty-workflow-link"
                        aria-label={`View Leadership P2B Workflow ${workflowId} in PagerDuty`}
                        title={`Open workflow ${workflowId} in PagerDuty (opens in new tab)`}
                      >
                        <FaExternalLinkAlt className="pagerduty-link-icon" />
                        View in PagerDuty
                      </a>
                    </Form.Text>
                  ) : null;
                })()}
              </Col>
            </Row>
            <Row>
              <Col>
                <Form.Group className="mb-3" controlId="products">
                  <Form.Label>Products</Form.Label>
                  <CreateMenu
                    isMultiple={true}
                    onChange={handleProductChange}
                    creatableCallback={handleProductCreate}
                    readOnly={isReadOnlyMode}
                    options={details.products}
                    defaultValue={details.products}
                  />
                </Form.Group>
              </Col>
            </Row>

            {/* Generated by GitHub Copilot */}
            {/* User Search Interface for Incident Commanders */}
            <div className="incident-commanders-section">
              <Row>
                <Col>
                  <h5 className="incident-commanders-title">
                    Incident Commanders
                    {/* Generated by GitHub Copilot */}
                    {isReadOnlyMode && (
                      <span className="badge bg-secondary ms-2 fs-6">
                        Read Only
                      </span>
                    )}
                  </h5>
                </Col>
              </Row>

              {/* Generated by GitHub Copilot */}
              {hasConfigurationPrivilege ? (
                <>
                  <Row>
                    <Col xl={8} sm={8} md={8} lg={8}>
                      <Form.Group className="mb-3" controlId="userSearch">
                        <Form.Label>Search Users by Last Name</Form.Label>
                        <Form.Control
                          type="text"
                          placeholder="Enter last name (minimum 2 characters)"
                          value={searchTerm}
                          onChange={handleSearchTermChange}
                          onKeyPress={handleSearchKeyPress}
                          disabled={searchLoading}
                        />
                      </Form.Group>
                    </Col>
                    <Col xl={4} sm={4} md={4} lg={4}>
                      <Form.Group className="mb-3">
                        <Form.Label>&nbsp;</Form.Label>
                        <div>
                          <Button
                            variant="primary"
                            onClick={searchUsers}
                            disabled={searchLoading || searchTerm.length < 2}
                          >
                            {searchLoading ? (
                              <span className="search-loading">
                                Searching...
                              </span>
                            ) : (
                              "Search Users"
                            )}
                          </Button>
                        </div>
                      </Form.Group>
                    </Col>
                  </Row>

                  {/* Search Error Display */}
                  {searchError && (
                    <Row>
                      <Col>
                        <div className="search-error" role="alert">
                          {searchError}
                        </div>
                      </Col>
                    </Row>
                  )}

                  {/* Search Results Display */}
                  {showSearchResults && (
                    <Row>
                      <Col>
                        <Form.Group className="mb-3">
                          <Form.Label>
                            Search Results ({searchResults.length} users found)
                          </Form.Label>
                          {searchResults.length > 0 ? (
                            <div className="search-results-container">
                              {searchResults.map((user, index) => {
                                const isSelected = isCommanderSelected(user);
                                const isAlreadyAssigned =
                                  isCommanderAlreadyAssigned(user);

                                return (
                                  <div
                                    key={user.id || index}
                                    className={`search-result-item ${
                                      isSelected ? "selected" : ""
                                    } ${
                                      isAlreadyAssigned
                                        ? "already-assigned"
                                        : ""
                                    }`}
                                  >
                                    <div className="d-flex align-items-center">
                                      <Form.Check
                                        type="checkbox"
                                        id={`commander-${user.id || index}`}
                                        checked={isSelected}
                                        disabled={isAlreadyAssigned}
                                        onChange={() =>
                                          handleCommanderSelect(user)
                                        }
                                        className="commander-checkbox"
                                      />
                                      <div className="commander-info">
                                        <div className="search-result-name">
                                          {user.displayName}
                                          {isAlreadyAssigned && (
                                            <span className="assigned-badge">
                                              Already Assigned
                                            </span>
                                          )}
                                        </div>
                                        <div className="search-result-details">
                                          {user.mail} • {user.givenName}{" "}
                                          {user.surname}
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                );
                              })}
                            </div>
                          ) : (
                            <div className="text-muted">No users found</div>
                          )}
                        </Form.Group>

                        {/* Generated by GitHub Copilot */}
                        {/* Assignment Actions */}
                        {searchResults.length > 0 &&
                          selectedCommanders.length > 0 && (
                            <div className="assignment-actions">
                              <Button
                                variant="success"
                                onClick={assignSelectedCommanders}
                                className="me-2"
                              >
                                {`Add Selected (${selectedCommanders.length})`}
                              </Button>
                              <Button
                                variant="outline-secondary"
                                onClick={() => setSelectedCommanders([])}
                              >
                                Clear Selection
                              </Button>
                            </div>
                          )}
                      </Col>
                    </Row>
                  )}

                  {/* Generated by GitHub Copilot */}
                  {/* Assignment Status Messages */}
                  {assignmentError && (
                    <Row>
                      <Col>
                        <div className="assignment-error" role="alert">
                          {assignmentError}
                        </div>
                      </Col>
                    </Row>
                  )}

                  {assignmentSuccess && (
                    <Row>
                      <Col>
                        <div className="assignment-success" role="alert">
                          {assignmentSuccess}
                        </div>
                      </Col>
                    </Row>
                  )}

                  {/* Generated by GitHub Copilot */}
                  {/* Current Commanders Display */}
                  {currentCommanders.length > 0 && (
                    <Row>
                      <Col>
                        <Form.Group className="mb-3">
                          <Form.Label>
                            Current Incident Commanders (
                            {currentCommanders.length})
                          </Form.Label>
                          <div className="current-commanders-container">
                            {currentCommanders.map((commander, index) => (
                              <div
                                key={index}
                                className="current-commander-item d-flex justify-content-between align-items-center"
                              >
                                <div className="commander-name">
                                  {commander}
                                </div>
                                <Button
                                  variant="outline-danger"
                                  size="sm"
                                  onClick={() => removeCommander(commander)}
                                  title="Remove commander"
                                >
                                  Remove
                                </Button>
                              </div>
                            ))}
                          </div>
                        </Form.Group>
                      </Col>
                    </Row>
                  )}
                </>
              ) : (
                /* Generated by GitHub Copilot */
                /* Read-only view for incident commanders */
                currentCommanders.length > 0 && (
                  <Row>
                    <Col>
                      <Form.Group className="mb-3">
                        <Form.Label>
                          Current Incident Commanders (
                          {currentCommanders.length})
                        </Form.Label>
                        <div className="current-commanders-readonly">
                          {currentCommanders.map((commanderName, index) => (
                            <div
                              key={index}
                              className="commander-item-readonly"
                            >
                              <span className="commander-name">
                                {commanderName}
                              </span>
                            </div>
                          ))}
                        </div>
                        <Form.Text className="text-muted">
                          Configuration privilege required to modify incident
                          commanders.
                        </Form.Text>
                      </Form.Group>
                    </Col>
                  </Row>
                )
              )}
            </div>

            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: '2rem', gap: '1rem' }}>
              {/* Left side: Cancel button */}
              <div>
                <Button
                  variant="outline-secondary"
                  onClick={() => navigate('/configuration')}
                >
                  Cancel
                </Button>
              </div>

              {/* Right side: Save Changes button */}
              <div>
                {hasConfigurationPrivilege ? (
                  <Button
                    disabled={saved}
                    variant="success"
                    onClick={saveChanges}
                  >
                    Save Changes
                  </Button>
                ) : (
                  <Button
                    disabled={true}
                    variant="secondary"
                    title="Configuration privilege required to save changes"
                  >
                    Save Changes (Read-Only)
                  </Button>
                )}
              </div>
            </div>
          </Form>
        </>
      )}

      <ConfirmationModal
        isOpen={showDeleteModal}
        onClose={() => {
          setShowDeleteModal(false);
          setStreamToDelete(null);
          setDeleteFromDetail(false);
        }}
        onConfirm={deleteFromDetail ? confirmDeleteProduct : handleDelete}
        title="Delete Delivery Stream"
        message={`Are you sure you want to delete "${streamToDelete?.name || 'this delivery stream'}"? This action cannot be undone.`}
        confirmText="Delete"
        cancelText="Cancel"
        variant="danger"
      />
    </Container>
  );
}

export default Management;
